import {Component, Emit, Mixins, Prop} from 'vue-property-decorator'
import {Company, CompanyTypeEnum, IVendorPriceListEntry, PriceList} from '@/firestore'
import AuthMixin from '@/mixins/AuthMixin.vue'

@Component
export default class PriceListSelector extends Mixins(AuthMixin) {
  @Prop({type: Object, required: true})
  public value!: IVendorPriceListEntry

  @Prop({type: Array, required: true})
  public priceLists!: PriceList[]

  @Prop({type: Boolean, default: false})
  public disabled!: boolean

  public search: string = ''

  public vendors: Company[] = []

  public rules = {
    entry: [
      (priceListId: string) => !!priceListId || 'Please select a vendor'
    ]
  }

  public async mounted() {
    const companyService = await this.$companyService
    this.vendors = companyService.watchCompaniesByType(CompanyTypeEnum.VENDOR)
  }

  public lookupVendorName(vendorCompanyId: string): string {
    const vendor = this.vendors.find((c: Company) => c.id === vendorCompanyId)
    return vendor ? vendor.displayName : ''
  }

  public lookupRepName(priceList: PriceList) {
    return priceList && priceList.vendorRepName
      ? ` - ${priceList.vendorRepName}`
      : ''
  }

  get entries() {
    return this.priceLists
      .map((priceList: PriceList) => ({
        priceList: priceList ? priceList : undefined,
        priceListId: priceList.id,
        vendorCompanyId: priceList.vendorCompanyId,
        vendorName: `${this.lookupVendorName(priceList.vendorCompanyId)}${this.lookupRepName(priceList)}`
      }))
      .sort((a, b) => {
        return new Intl.Collator('en', {numeric: true}).compare(
          a.vendorName || '',
          b.vendorName || ''
        )
      })
  }

  @Emit('updateEntry')
  public async updateEntry(entry: IVendorPriceListEntry) {
    return {
      ...this.value,
      ...entry
    }
  }

  @Emit('addVendor')
  public addVendor() {
    return
  }

  public comparator(listValue: string, selectedValue: string) {
    return this.value.priceListId === listValue
  }
}
